<template>
  <div class="download-user">
    <table class="bk-table">
      <thead>
        <colgroup>
          <col style="width:138px">
          <col style="width:138px">
          <col style="width:138px">
          <col style="width:138px">
          <col style="width:138px">
          <col style="width:221px">
        </colgroup>
        <tr>
          <th class="first">下载用户</th>
          <th style="width: 220px;">用户认证</th>
          <th>下载费用</th>
          <th>当前版本</th>
          <th style="width: 180px;">服务期限</th>
          <th style="width: 180px;">下载日期</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="!isLoading">
          <tr v-for="(item,index) in userList">
            <td>{{item.user_basic.user_name}}</td>
            <td>
              <div class="user-icon-list" v-if="item.user_basic.user_badges.includes(true)">
                <a href="javascript:;" v-if="item.user_basic.user_badges[0]">
                  <i class="badge-icon icon-medal" :class="{'gray': !item.user_basic.user_badges[0]}"></i>
                  <span class="tips">官方授权服务商</span>
                </a>
                <a href="javascript:;" v-if="item.user_basic.user_badges[1]">
                  <i class="badge-icon icon-medal2" :class="{'gray': !item.user_basic.user_badges[1]}"></i>
                  <span class="tips">蓝鲸官方</span>
                </a>
                <a href="javascript:;" v-if="item.user_basic.user_badges[2]">
                  <i class="badge-icon icon-medal4" :class="{'gray': !item.user_basic.user_badges[2]}"></i>
                  <span class="tips">企业认证</span>
                </a>
                <a href="javascript:;" v-if="item.user_basic.user_badges[3]">
                  <i class="badge-icon icon-medal3" :class="{'gray': !item.user_basic.user_badges[3]}"></i>
                  <span class="tips">实名认证</span>
                </a>
                <a href="javascript:;" v-if="item.user_basic.user_badges[4]">
                  <i class="badge-icon icon-medal5" :class="{'gray': !item.user_basic.user_badges[4]}"></i>
                  <span class="tips">蓝鲸开发者认证</span>
                </a>
              </div>
              <span v-else>无</span>
            </td>
            <td>{{item.price}}</td>
            <td>{{item.version}}</td>
            <td>{{item.service_range}}</td>
            <td>{{item.time}}</td>
          </tr>
        </template>
        <tr class="attention-null" v-show="isNullData&&!isLoading" style="padding-top: 100px">
          <td colspan="6" style="border-top:0;border-bottom: 0">
            <img src="../../../images/personal_center/work-null.png" alt="">
            <p>未有用户下载</p>
          </td>
        </tr>
      </tbody>
    </table>
    <v-page v-if="page.total&&!isLoading" :page="page" class="pages"></v-page>
    <loading :ifLoadingStart="isLoading" class="loading"></loading>
  </div>
</template>

<script type="text/javascript">
  import loading from '../../loading.vue' //导入加载子组件
  import vPage from "../../page.vue";
  export default {
    data() {
      return {
        userList: [], //下载用户列表
        isLoading: true,
        isNullData: false,
        options: {
          msgIsSuccess: '',
          msgText: ''
        },
        page: {  // 页码相关
          total: 0,
          curPage: 1,
          totalPage: 1
        }
        
      }
    },
    watch: {
      "page.curPage": {
        handler: function(newVal, oldVal){
         this.pageTurning(newVal);
        }
      }
    },
    methods: {
      //翻页功能
      pageTurning() {
        this.isLoading = true;
        let page = this.page;
        const app_id = this.$route.params.wid;
        if (page.curPage < 1 || page.curPage >page.totalPage) {
          return;
        }
        axios.get(myUrl + `core/product/${app_id}/download/history/?page=${page.curPage}&page_size=${page.total}`).
        then((res) => {
          if(res.data.result) {
            this.isLoading = false;
            let resData = res.data.data;
            this.userList = resData.data;
            this.page.total = resData.page_size;
            this.page.curPage = resData.page;
            this.page.totalPage = Math.ceil(resData.total/resData.page_size);
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }

        })
      },
      getUserList() {
        const app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/${app_id}/download/history/`).
        then((res) => {
          if (res.data.result) {
            this.isLoading = false;
            if (res.data.data.data.length) {
              let resData = res.data.data;
              this.userList = resData.data;
              this.page.total = resData.page_size;
              this.page.curPage = resData.page;
              this.page.totalPage = Math.ceil(resData.total/resData.page_size);
            } else {
              this.isNullData = true;
            }
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      }
    },
    created() {
      this.getUserList();
    },
    components: {
      loading,
      "v-page": vPage
    }
  }
</script>
<style media="screen" lang="scss">
  .user-icon-list{
    padding-top: 10px;
    >a{
      position: relative;
      color: #fff;
      .tips{
        display: none;
        background: #090b1a;
        position: absolute;
        top: -40px;
        left: -45px;
        width: 110px;
        height: 30px;
        line-height: 30px;
        border-radius: 2px;
        text-align: center;
        &:after{
          content: '';
          position: absolute;
          left: 50%;
          bottom: -14px;
          width: 0;
          height: 0;
          border: 10px solid #090b1a;
          border-color: #090b1a transparent transparent transparent;
          margin-left: -10px;
        }
      }
      &:hover{
        .tips{
          display: block;
        }
      }
    }
    .badge-icon{
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      margin-right: 5px;
    }
    .icon-medal{
      width: 20px;
      height: 19px;
      background: url(../../../images/common/icon-medal.png) no-repeat;
      &.gray{
        background: url(../../../images/common/icon-medal-gray.png) no-repeat;
      }
    }
    .icon-medal2{
      width: 20px;
      height: 20px;
      background: url(../../../images/common/icon-medal2.png) no-repeat;
      &.gray{
        background: url(../../../images/common/icon-medal2-gray.png) no-repeat;
      }
    }
    .icon-medal3{
      width: 23px;
      height: 15px;
      background: url(../../../images/common/icon-medal3.png) no-repeat;
      &.gray{
        background: url(../../../images/common/icon-medal3-gray.png) no-repeat;
      }
    }
    .icon-medal4{
      width: 19px;
      height: 19px;
      background: url(../../../images/common/icon-medal4.png) no-repeat;
      &.gray{
        background: url(../../../images/common/icon-medal4-gray.png) no-repeat;
      }
    }
    .icon-medal5{
      width: 19px;
      height: 18px;
      background: url(../../../images/common/icon-medal5.png) no-repeat;
      &.gray{
        background: url(../../../images/common/icon-medal5-gray.png) no-repeat;
      }
    }
  }
  .download-user {
    .bk-table {
      border: none;
      >thead {
        >tr {
          >th {
            border-top: none;
          }
        }
      }
    }
    .loading {
      margin-top: 160px;
    }
  }
</style>

<style media="screen" lang="scss" scoped>
  td,
  th {
    padding: 0 10px !important;
    background-color: #ffffff !important;
    height: 58px !important;
    vertical-align: middle !important;
    text-align: center;
    &.first {
      padding-left: 30px !important;
    }
    &:nth-child(1) {
      width: 138px;
    }
    &:nth-child(2) {
      width: 138px;
    }
    &:nth-child(3) {
      width: 138px;
    }
    &:nth-child(4) {
      width: 138px;
    }
    &:nth-child(5) {
      width: 138px;
    }
    &:nth-child(6) {
      width: 221px;
    }
  }

  th {
    color: #4f515e !important;
    font-weight: normal !important;
    border-bottom: 2px solid #e6e6e7 !important;
  }

  td {
    font-size: 14px !important;
    border-bottom: 1px solid #e6e6e7 !important;
  }


  tbody {

    .attention-null {
      width:911px;
      height:300px;
   
      background-color: transparent;
      td {
      
       height:105;
        width: 100%;
        border-bottom: 0 !important;
      }
    }
   
  }


  .icon {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    display: inline-block;
    color: #ffffff;
    margin: 0 5px 5px 0;
    &.black {
      background: #000000;
    }
    &.yellow {
      background: #ffb400;
    }
    &.green {
      background: #30d878;
    }
    &.blue {
      background: #3c96ff;
    }
  }

  tbody {
    .none {
      display: none;
    }

  }
  .paging{
      margin: 28px 28px 28px 0;
      text-align: right;
    }
</style>


// WEBPACK FOOTER //
// download_user.vue?74ce6169